import { yupResolver } from '@hookform/resolvers/yup';
import moment from "moment-timezone";
import React, { useCallback, useEffect, useState, useRef } from "react";
import { Button, Col, Container, Form, InputGroup, Row, Table, Navbar } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Helmet } from "react-helmet";
import { Controller, useForm } from 'react-hook-form';
import { FaPlus, FaSearch } from "react-icons/fa";
import Loader from "react-js-loader";
import Moment from 'react-moment';
import { NumericFormat } from 'react-number-format';
import { Link, useNavigate, useParams } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import * as Yup from 'yup';
import { alertService } from "../../Utils/AlertService/alert.service";
import BsAlert from "../../Utils/BsAlert";
import { getEndpointUrl } from "../../Utils/Common";
import ModalSelectInvoice from "../Invoice/ModalSelectInvoice";
import { HiArrowLeft } from 'react-icons/hi';
import Header from "../../Layout/Header";
import SidebarMenu from "../../Layout/SidebarMenu";
import { useMediaQuery } from 'react-responsive';
import { Toast } from 'primereact/toast';

const CreatePurchaseInvoice = () => {
    const [isLoading, setLoading] = useState(true);
    const [saveLoading, setSaveLoading] = useState(false);
    
    const toast = useRef(null);

    const [accesToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    const [userLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const navigate = useNavigate();

    const [sidebarVisible, setSidebarVisible] = useState(false);

    const isMobile = useMediaQuery({ query: '(max-width: 600px)' });
    const isTabletOrLaptop = useMediaQuery({ query: '(min-width: 600px)' });

    const params = useParams();

    const [invoice, setInvoice] = useState([]);

    const [modalSelectOffer, setModalSelectOffer] = useState(false);

    const [dateSelected, setDateSelected] = useState(new Date());

    const fetchDataInvoice = useCallback(async (invoice_id) => {
        setLoading(true);
        fetch(getEndpointUrl() + `/invoice/${invoice_id !== undefined ? invoice_id : 0}`, {
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            if (json.status === 'ok') {
                setInvoice(json.results);

                let defaultValues = {};
                defaultValues.invoice_id = invoice_id;
                defaultValues.customerName = json.results.customerName;
                defaultValues.amount = json.results.amount;
                reset({ ...defaultValues });
            } else {
                let defaultValues = {};
                defaultValues.invoice_id = '';
                defaultValues.customerName = '';
                defaultValues.amount = '';
                reset({ ...defaultValues });
            }

            setLoading(false);
        });
    }, []);

    const validationSchema = Yup.object().shape({
        date: Yup.string().required('Field harus diisi'),
        invoice_id: Yup.number().nullable().typeError("Field berupa angka").required('Field harus diisi'),
        amount: Yup.number().when('isBig', (isBig, schema) => {
            return isBig ? schema.max(invoice.amount, `Total pembayaran melebihi penagihan.`) : schema.max(25000);
        }).nullable().typeError("Field berupa angka").required('Field harus diisi'),
        description: Yup.string().required('Field harus diisi')
    });

    const { register, handleSubmit, reset, control, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema)
    });

    //   const { errors } = formState;

    useEffect(() => {
        fetchDataInvoice(params.invoice_id);
    }, [params, fetchDataInvoice, reset]);

    const onSubmit = data => {

        setSaveLoading(true);

        let formData = new FormData();    //formdata object

        formData.append('invoice_id', data.invoice_id);
        formData.append('date', moment(data.date).format('YYYY-MM-DD'));
        formData.append('amount', invoice.amount);
        formData.append('amountPaid', data.amount);
        formData.append('description', data.description);
        formData.append('user_id', userLogin.id);

        fetch(getEndpointUrl() + '/purchase', {
            method: "POST",
            body: formData,
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            setSaveLoading(false);

            if (json.status === 'ok') {
                toast.current.show({ severity: 'success', summary: 'Berhasil', detail: 'Yeay, Pembayaran berhasil diinput.' });
                reset();
                let defaultValues = {};
                defaultValues.invoice_id = '';
                defaultValues.description = '';
                defaultValues.amount = '';
                reset({ ...defaultValues });
                navigate('/pembayaran/create');
            } else {
                toast.current.show({ severity: 'warn', summary: 'Berhasil', detail: json.message });
            }
        }).catch(error => {
            setSaveLoading(false);
        });
    };

    const onCallbackSelectInvoice = useCallback((e) => {
        navigate(`/pembayaran/create/${e.id}`);
    }, []);

    return (
        <>
            <Helmet>
                <title>Input Pembayaran</title>
            </Helmet>
            <Toast ref={toast} />
            <div className="d-block d-sm-none">
                <Navbar expand="lg" className="mainNavbar border-bottom mb-3" sticky="top">
                    <a href="#" onClick={() => navigate(-1)} className="navBackMenu">
                        <HiArrowLeft />
                    </a>
                    <strong className="me-auto navTitle">Input Pembayaran</strong>
                    <Navbar.Toggle className="d-block d-sm-none me-3" onClick={(e) => setSidebarVisible(true)} />
                </Navbar>
            </div>
            <div className="d-none d-sm-inline">
                <Header />
            </div>
            <SidebarMenu show={sidebarVisible} close={(e) => setSidebarVisible(false)} />
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Container className="mt-3 mb-5">
                    <Row>
                        <Col md={7}>
                            <div className="d-none d-sm-inline">
                                <div className="mt-3 fw-bold">Input Pembayaran</div>
                            </div>
                            <Row>
                                <Col>
                                    <BsAlert />
                                </Col>
                            </Row>
                            <Row className="mt-3 mb-3">
                                <Col md={10}>
                                    <Form.Label>Tagihan :</Form.Label>
                                    <InputGroup>
                                        <Controller
                                            render={({ field }) => (
                                                <Form.Control {...field}
                                                    type="number"
                                                    placeholder="Pilih Tagihan"
                                                    readOnly
                                                    disabled
                                                    isInvalid={errors.invoice_id ? true : false} />
                                            )}
                                            control={control}
                                            defaultValue={params.id}
                                            name="invoice_id"
                                        />
                                        <Button variant="outline-secondary" onClick={(e) => setModalSelectOffer(true)}><FaSearch /> Cari</Button>
                                        <Link to="/invoice/create" className="btn btn-outline-secondary"><FaPlus /> Tambahkan</Link>
                                    </InputGroup>
                                    <ModalSelectInvoice onCallback={onCallbackSelectInvoice} show={modalSelectOffer} close={(e) => setModalSelectOffer(false)} />
                                    <Form.Text className="text-muted fs-13 clearfix">{errors.invoice_id?.message}</Form.Text>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Tanggal Pembayaran :</Form.Label>
                                        <Controller
                                            control={control}
                                            name="date"
                                            render={({ field }) => (
                                                <DatePicker
                                                    startDate={dateSelected}
                                                    minDate={invoice && new Date(invoice.invoiceDate)}
                                                    className={errors.date ? `is-invalid` : ``}
                                                    disabled={saveLoading}
                                                    isInvalid={errors.date ? true : false}
                                                    autoComplete="off"
                                                    onChange={(date) => {
                                                        field.onChange(date);
                                                        setDateSelected(date)
                                                    }}
                                                    selected={field.value}
                                                    customInput={<Form.Control />}
                                                />
                                            )}
                                        />
                                        <Form.Text className="text-muted fs-13 clearfix">{errors.date?.message}</Form.Text>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Total Pembayaran :</Form.Label>
                                        <Form.Control type="number" {...register("amount")} isInvalid={errors.amount ? true : false} disabled={saveLoading || isLoading} autoComplete="off" />
                                        <Form.Text className="text-muted fs-13 clearfix">{errors.amount?.message}</Form.Text>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Deskripsi :</Form.Label>
                                        <Form.Control type="text" as={'textarea'} rows={5}  {...register("description")} isInvalid={errors.description ? true : false} disabled={saveLoading} autoComplete="off" />
                                        <Form.Text className="text-muted fs-13 clearfix">{errors.description?.message}</Form.Text>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mt-3 mb-5">
                                <Col md={12} className="d-flex justify-content-end">
                                    <Link to={"/pembayaran"} title="Batal" className="btn btn-secondary me-3">Batal</Link>
                                    <Button type="submit" disabled={saveLoading}>{saveLoading ? "Mengirim data..." : "Buat Pembayaran"}</Button>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={5}>
                            <div className="mt-5 fw-bold">Tagihan</div>
                            <Table className="mt-2 fs-13">
                                <tbody>
                                    <tr>
                                        <td className="text-muted" width={120}>Tagihan ID</td>
                                        <td className="text-center" width={20}>:</td>
                                        <td className="fw-medium">
                                            {isLoading ?
                                                <div className="loader-text">
                                                    <Loader type="bubble-scale" bgColor={"#42A5F5"} size={25} />
                                                </div> :
                                                invoice.id
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted" width={120}>Tanggal dibuat</td>
                                        <td className="text-center" width={20}>:</td>
                                        <td className="fw-medium">
                                            {isLoading ?
                                                <div className="loader-text">
                                                    <Loader type="bubble-scale" bgColor={"#42A5F5"} size={25} />
                                                </div> : params.invoice_id !== undefined &&
                                                <>
                                                    <strong><Moment format="D MMM YYYY">{invoice.createdAt}</Moment></strong>
                                                    <span className="text-muted fw-medium"><Moment format=" - HH:mm A">{invoice.createdAt}</Moment></span>
                                                </>
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted" width={120}>Periode Penagihan</td>
                                        <td className="text-center" width={20}>:</td>
                                        <td className="fw-medium">
                                            {isLoading ?
                                                <div className="loader-text">
                                                    <Loader type="bubble-scale" bgColor={"#42A5F5"} size={25} />
                                                </div> : params.invoice_id !== undefined &&
                                                <>
                                                    <strong><Moment format="D MMM YYYY">{invoice.invoiceDate}</Moment></strong>
                                                    <span className="px-2">-</span>
                                                    <strong><Moment format="D MMM YYYY">{invoice.doeDate}</Moment></strong>
                                                </>
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted">Nama Pelanggan</td>
                                        <td className="text-center">:</td>
                                        <td className="fw-bold">
                                            {isLoading ?
                                                <div className="loader-text">
                                                    <Loader type="bubble-scale" bgColor={"#42A5F5"} size={25} />
                                                </div> :
                                                invoice.customerName
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted">Email</td>
                                        <td className="text-center">:</td>
                                        <td className="fw-medium">
                                            {isLoading ?
                                                <div className="loader-text">
                                                    <Loader type="bubble-scale" bgColor={"#42A5F5"} size={25} />
                                                </div> :
                                                invoice.customerEmail
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted">No Handphone</td>
                                        <td className="text-center">:</td>
                                        <td className="fw-medium">
                                            {isLoading ?
                                                <div className="loader-text">
                                                    <Loader type="bubble-scale" bgColor={"#42A5F5"} size={25} />
                                                </div> :
                                                invoice.customerPhone
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted">Alamat</td>
                                        <td className="text-center">:</td>
                                        <td className="fw-medium">
                                            {isLoading ?
                                                <div className="loader-text">
                                                    <Loader type="bubble-scale" bgColor={"#42A5F5"} size={25} />
                                                </div> :
                                                invoice.customerAddress
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted" width={150}>Deskripsi</td>
                                        <td className="text-center" width={20}>:</td>
                                        <td className="fw-medium">
                                            {isLoading ?
                                                <div className="loader-text">
                                                    <Loader type="bubble-scale" bgColor={"#42A5F5"} size={25} />
                                                </div> :
                                                invoice.noteDescription
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted">Harga</td>
                                        <td className="text-center">:</td>
                                        <td className="fw-bold">
                                            {isLoading ?
                                                <div className="loader-text">
                                                    <Loader type="bubble-scale" bgColor={"#42A5F5"} size={25} />
                                                </div> :
                                                <NumericFormat
                                                    value={invoice.amount}
                                                    displayType={'text'}
                                                    thousandSeparator={true}
                                                    prefix={'Rp'}
                                                    renderText={(value, props) => <span {...props}>{value}</span>} />
                                            }
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </Container>
            </Form>
        </>
    );
}

export default CreatePurchaseInvoice;